import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="bg-[#22243a] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Main illustration */}
        <img
          className="absolute right-0 md:-right-10 lg:-right-20 top-[20%] w-[108vw] max-w-[2229px] h-auto opacity-100 hidden lg:block"
          style={{ filter: 'brightness(1.08) contrast(1.05)' }}
          src={require('../assets/img/hero/illustration.png')}
          alt=""
        />

        {/* Decorative circles group */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[30%] w-[60vw] max-w-[1016px] aspect-square opacity-25 hidden md:block">
          <div
            className="absolute inset-0 rounded-full opacity-10"
            style={{ background: 'radial-gradient(50% 50% at -29% 62%, rgba(137, 146, 208, 1) 3%, rgba(169, 176, 229, 1) 100%)' }}
          />
          <div
            className="absolute left-1/2 -translate-x-1/2 top-[17%] w-[65%] h-[65%] rounded-full opacity-25"
            style={{ background: 'radial-gradient(50% 50% at -29% 62%, rgba(137, 146, 208, 1) 3%, rgba(169, 176, 229, 1) 100%)' }}
          />
          <div
            className="absolute left-1/2 -translate-x-1/2 top-[30%] w-[39%] h-[39%] rounded-full opacity-45"
            style={{ background: 'radial-gradient(50% 50% at -29% 62%, rgba(137, 146, 208, 1) 3%, rgba(169, 176, 229, 1) 100%)' }}
          />
        </div>

        {/* Blurred glows */}
        <div className="absolute right-[30%] bottom-[20%] w-[197px] h-[197px] rounded-full bg-[#4452e326] blur-[18px] hidden lg:block" />
        <div
          className="absolute left-1/2 -translate-x-1/2 top-[40%] w-[757px] h-[59px] bg-[#ffffff26] blur-[18px] hidden lg:block"
          style={{ borderRadius: '378.5px / 29.5px' }}
        />

        {/* Corner brackets — hidden on mobile */}
        <img className="absolute left-2 top-2 w-[100px] lg:w-[128px] h-auto hidden lg:block" src={require('../assets/img/hero/corner-tl.png')} alt="" />
        <img className="absolute left-2 bottom-2 w-[100px] lg:w-[128px] h-auto hidden lg:block" src={require('../assets/img/hero/corner-bl.png')} alt="" />
        <img className="absolute right-2 bottom-2 w-[100px] lg:w-[128px] h-auto hidden lg:block" src={require('../assets/img/hero/corner-br.png')} alt="" />
        <img className="absolute right-2 top-2 w-[100px] lg:w-[128px] h-auto hidden lg:block" src={require('../assets/img/hero/corner-tr.png')} alt="" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 py-16 lg:py-28 text-center">
        {/* WE BUILD YOUR IDEAS INTO REALITY */}
        <div className="relative mb-6 lg:mb-8">
          <div className="font-exo font-black text-white text-4xl lg:text-[80px] tracking-[4px] leading-tight">
            WE BUILD
          </div>
          <div className="relative my-2 lg:my-4">
            <div className="absolute inset-0 bg-royal-blue rotate-[1.52deg] -z-10 scale-x-105 scale-y-[1.4]" />
            <img
              className="w-full max-w-[725px] mx-auto h-auto"
              src={require('../assets/img/hero/your-ideas.svg').default}
              alt="YOUR IDEAS"
            />
          </div>
          <div className="font-exo font-bold text-white text-4xl lg:text-[75px] tracking-[8px] lg:tracking-[19.2px] leading-tight">
            INTO REALITY
          </div>
        </div>

        {/* Tagline */}
        <div className="mb-4 lg:mb-6">
          <p className="font-proxima-bold font-bold text-xl lg:text-[30px] tracking-[0.45px] leading-normal">
            <span className="text-[#a1aaff]">Turn your </span>
            <span className="text-white">business vision</span>
            <span className="text-[#a1aaff]"> into </span>
            <span className="text-white">working software</span>
          </p>
          {/*<div className="flex justify-center gap-8 mt-1">
            <img className="w-[150px] lg:w-[226px] h-[7px]" src={require('../assets/img/hero/underline-left.svg').default} alt="" />
            <img className="w-[170px] lg:w-[256px] h-[7px]" src={require('../assets/img/hero/underline-right.svg').default} alt="" />
          </div>*/}
        </div>

        {/* Subtitle */}
        <p className="font-proxima-semibold text-white text-base lg:text-xl tracking-[1px] leading-normal mb-6 lg:mb-8 max-w-[752px] mx-auto">
          We start by understanding exactly what you need and documenting every detail. Then, our expert developers combine advanced technology with intelligent AI to build your solution faster, smarter, and with precision.
          <br /><br />
          No surprises. No confusion. Just powerful software—built exactly as you envisioned.
        </p>

        {/* Stats line */}
        <p className="font-proxima-bold font-bold text-white text-base lg:text-xl tracking-[1px] leading-normal mb-8 lg:mb-10">
          17+ years of excellence &bull; AI-powered innovation &bull; Comprehensive documentation &bull; Proven results
        </p>

        {/* GET STARTED button */}
        <a
          href="#get-started"
          className="inline-flex items-center justify-center rounded-md overflow-hidden bg-royal-blue cursor-pointer py-3 px-5 lg:py-4 lg:px-8 hover:bg-opacity-90 transition-colors"
        >
          <span className="font-proxima-bold font-bold text-white text-base lg:text-2xl leading-6 whitespace-nowrap">
            GET STARTED
          </span>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
